/* tslint:disable */
/* eslint-disable */
/**
 * EVIMO API
 * Documentation
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { BareLogPreviewItemDto } from './BareLogPreviewItemDto';
import {
    BareLogPreviewItemDtoFromJSON,
    BareLogPreviewItemDtoFromJSONTyped,
    BareLogPreviewItemDtoToJSON,
    BareLogPreviewItemDtoToJSONTyped,
} from './BareLogPreviewItemDto';

/**
 * 
 * @export
 * @interface PaginatedBareLogsResponseDto
 */
export interface PaginatedBareLogsResponseDto {
    /**
     * 
     * @type {Array<BareLogPreviewItemDto>}
     * @memberof PaginatedBareLogsResponseDto
     */
    items: Array<BareLogPreviewItemDto>;
    /**
     * 
     * @type {number}
     * @memberof PaginatedBareLogsResponseDto
     */
    total: number;
    /**
     * 
     * @type {number}
     * @memberof PaginatedBareLogsResponseDto
     */
    page: number;
    /**
     * 
     * @type {number}
     * @memberof PaginatedBareLogsResponseDto
     */
    limit: number;
}

/**
 * Check if a given object implements the PaginatedBareLogsResponseDto interface.
 */
export function instanceOfPaginatedBareLogsResponseDto(value: object): value is PaginatedBareLogsResponseDto {
    if (!('items' in value) || value['items'] === undefined) return false;
    if (!('total' in value) || value['total'] === undefined) return false;
    if (!('page' in value) || value['page'] === undefined) return false;
    if (!('limit' in value) || value['limit'] === undefined) return false;
    return true;
}

export function PaginatedBareLogsResponseDtoFromJSON(json: any): PaginatedBareLogsResponseDto {
    return PaginatedBareLogsResponseDtoFromJSONTyped(json, false);
}

export function PaginatedBareLogsResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): PaginatedBareLogsResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'items': ((json['items'] as Array<any>).map(BareLogPreviewItemDtoFromJSON)),
        'total': json['total'],
        'page': json['page'],
        'limit': json['limit'],
    };
}

export function PaginatedBareLogsResponseDtoToJSON(json: any): PaginatedBareLogsResponseDto {
    return PaginatedBareLogsResponseDtoToJSONTyped(json, false);
}

export function PaginatedBareLogsResponseDtoToJSONTyped(value?: PaginatedBareLogsResponseDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'items': ((value['items'] as Array<any>).map(BareLogPreviewItemDtoToJSON)),
        'total': value['total'],
        'page': value['page'],
        'limit': value['limit'],
    };
}

